import React from 'react';
import { Image, StyleSheet, View, TouchableOpacity } from 'react-native';
import Icon from './Icon';
import { Color, CommonProperties, CommonStyles } from '../styles';
import BaseText from './BaseText';
import { scale } from '../utils/scale.utils';
import { CheckboxInner } from './Checkbox';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../store/selectors/auth.selector';
import { formatCurrency } from '../utils/currency.utils';

const OptionNavigateFilter = ({ title, desc, price, selected, icon, image, style, ...rest }) => {
  const currency = useSelector(selectCompanyCurrency);
  const currencyculture = useSelector(selectCompanyCurrencyCulture);

  return (
    <TouchableOpacity style={[styles.row, style]} {...rest}>
      {icon && <Icon style={styles.icon} name={icon} />}
      {image && <Image style={styles.image} source={image} />}
      <View style={CommonStyles.flex1}>
        <BaseText style={CommonStyles.h3}>{title}</BaseText>
        {desc && <BaseText style={styles.subtitle}>{desc}</BaseText>}
      </View>
      <BaseText style={styles.price}>
        {price ? formatCurrency(price, currency, currencyculture) : ''}
      </BaseText>
      <CheckboxInner selected={selected} />
    </TouchableOpacity>
  );
};

export default OptionNavigateFilter;

const iconSize = scale(32);
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomColor: '#eeeeee',
    borderBottomWidth: 1,
    ...CommonProperties.px3,
    ...CommonProperties.py2,
  },
  subtitle: {
    ...CommonProperties.body,
    color: '#888888',
  },
  icon: {
    fontSize: iconSize,
    width: iconSize,
    color: Color.primary,
    ...CommonProperties.mr3,
  },
  image: {
    height: scale(28),
    width: iconSize,
    resizeMode: 'contain',
    ...CommonProperties.mr3,
  },
  price: {
    ...CommonProperties.h2,
    ...CommonProperties.mr5,
  },
});
